import { isPossiblePhoneNumber } from 'libphonenumber-js';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const RESERVED_USERNAMES = [
  'admin', 'administrator', 'root', 'system', 'support', 'help',
  'abraham', 'test', 'user', 'demo', 'mindmirth',
  'guest', 'anonymous', 'null', 'undefined',
];

export function isEmailValid(value) {
  return EMAIL_REGEX.test(value);
}

export function isPhoneValid(value) {
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (trimmed.startsWith('+')) {
    return isPossiblePhoneNumber(trimmed);
  }
  return isPossiblePhoneNumber(trimmed, 'US');
}

export function validateUsername(value) {
  return {
    firstLetter: /^[a-zA-Z]/.test(value),
    lettersNumbersOnly: value.length > 0 && /^[a-zA-Z0-9]+$/.test(value),
    minLength: value.length >= 8,
    maxLength: value.length > 0 && value.length <= 20,
    available:
      value.length > 0 && !RESERVED_USERNAMES.includes(value.toLowerCase()),
  };
}

export function validatePassword(value) {
  return {
    minLength: value.length >= 6,
    hasLetter: /[a-zA-Z]/.test(value),
    hasNumber: /[0-9]/.test(value),
  };
}

export function validateConfirmPassword(password, confirmPassword) {
  return {
    match: password.length > 0 && password === confirmPassword,
  };
}

export function allMet(criteria) {
  return Object.values(criteria).every(Boolean);
}